import { render } from "./ButtonPanel.vue?vue&type=template&id=18254308&scoped=true&ts=true"
import script from "./ButtonPanel.vue?vue&type=script&lang=ts"
export * from "./ButtonPanel.vue?vue&type=script&lang=ts"

import "./ButtonPanel.vue?vue&type=style&index=0&id=18254308&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18254308"]])

export default __exports__